import React from 'react';
import { Col, Row, Card, CardBody, Button, Spinner } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function SnIntegration({ title, to, loading, test, check }) {
  console.log('check', check);
  return (
    <>
      <Col xs={6} className="col-xxl-4 mb-1 pr-md-2 pl-xxl-2">
        <Card className="mb-3 overflow-hidden" style={{ minWidth: '24rem', minHeight: '8rem' }}>
          {/* <Background className={`bg-card`} /> */}
          <CardBody className="position-relative">
            <Row>
              <Col>
                <h6 className="dash-vendor-label">{title}</h6>
              </Col>
              {loading ? (
                <Col className="text-right d-inline-flex flex-row-reverse">
                  <Spinner size={'sm'} color="primary" />
                </Col>
              ) : (
                <Col className="text-right d-inline-flex flex-row-reverse">
                  <p className={`branding-${check ? 'green' : 'red'} ${loading ? 'loading-skeleton' : ' '} small`}>
                    <span className="pb-2">{check ? 'OPERATIONAL' : 'ERROR'}</span>
                  </p>
                  <p className="small">
                    <span className="fa-stack fa-xs mr-1">
                      <FontAwesomeIcon icon="circle" className={`branding-${check ? 'green' : 'red'} fa-stack-2x`} />
                      <FontAwesomeIcon icon={check ? 'check' : 'exclamation'} className="fa-stack-1x" inverse />
                    </span>
                  </p>
                </Col>
              )}
            </Row>
            {loading ? (
              <div />
            ) : !check && to !== 'openai' ? (
              <div>
                <div className="col">
                  <div className="row">
                    <Link to={`/integrations/${to}`}>
                      <Button color="falcon-default" className="btn btn-falcon-default mt-2" size="sm">
                        Configure
                      </Button>
                    </Link>
                  </div>
                </div>

                <>
                  <div className="active">
                    <small>{test?.error?.message}</small>
                  </div>
                </>
              </div>
            ) : (
              <></>
            )}
          </CardBody>
        </Card>
      </Col>
    </>
  );
}

SnIntegration.propTypes = {
  title: PropTypes.string,
  to: PropTypes.string,
  test: PropTypes.object,
  check: PropTypes.bool,
  loading: PropTypes.bool
};
